import moment from 'moment';
import {
  KEY__CREDENTIAL__PRIMARY,
  KEY__CREDENTIAL__SECONDARY
} from '../../dictionaries/Credential.dic';
import {
  Arr
} from '../../lib/Array.lib';
import {
  NOT,
  YES
} from '../../lib/Boolean.lib';
import Candidate from '../../lib/Candidate';
import Core from '../../lib/Core';
import {
  TIMEZONE__LA
} from '../../lib/Date.lib';
import {
  ACCOUNT_ACTION__DOWNLOAD_CANDIDATES_CSV
} from '../../lib/Definition';
import globalErrorHandler from '../../lib/Error/globalErrorHandler.fun';
import useState from '../../lib/hooks/useState.hook';
import {
  mapCandidateInfoForCSV
} from '../../lib/models/mapCandidateInfo.tool';
import {
  Obj
} from '../../lib/Object.lib';
import {
  mapContactsToStrings,
  sendSafeEmail,
  TEN_BY_TEN__RECRUITER_CONTACT
} from '../../lib/services/Email/Email.lib';
import {
  encodeBase64,
  Str
} from '../../lib/String.lib';
import Box from '../Layout/Wrappers/Box';
import Button from '../Layout/Wrappers/Button';
import Icon from '../Layout/Wrappers/Icon';
import Menu from '../Layout/Wrappers/Menu';
import Loader from '../Shared/Loader';
import DownloadCSV, {
  convertToCSV
} from '../Tools/DownloadCSV';
import {
  getControllerCandidates
} from './Candidates';

export const KEY__CANDIDATES_EXPORT_CSV = 'KEY__CANDIDATES_EXPORT_CSV';

export function getControllerCandidatesExportCSV() {
  return Obj(Core.getKeyValue(KEY__CANDIDATES_EXPORT_CSV));
}

export function setControllerCandidatesExportCSV(controller) {
  return Core.setKeyValue(KEY__CANDIDATES_EXPORT_CSV, controller);
}

export default function CandidatesExportCSV({
  acl = false,
  ...props
}) {

  const [state, updateState] = useState();
  setControllerCandidatesExportCSV({ state, updateState });

  if (NOT(acl)) { return null; }

  const Candidates = getControllerCandidates();

  const candidatesState = Obj(Candidates.state);

  const _mapSourceFields = (candidate) => {
    candidate = { ...candidate };
    candidate.__exportDate = moment().format('MM-DD-YYYY');
    candidate.__exportOwner = Core.getUserName();
    return candidate;
  }

  const selectedCandidates = candidatesState.allCandidates.filter(
    (candidate) => !!candidate.__selected
  ).map(_mapSourceFields);

  const starredCandidates = candidatesState.allCandidates.filter(
    (candidate) => !!candidate.starred
  ).map(_mapSourceFields);

  const YES__SHOW__UNSTAR_ALL = (
    YES(state.showUnstarAll) &&
    YES(starredCandidates.length)
  );

  const YES__SENDING_EMAIL = YES(state.sendingEmail);

  const unstarAllCandidates = async (event) => {
    event.stopPropagation();
    try {
      for (let i = 0; i < starredCandidates.length; i++) {
        await Candidate.updateStarred(
          starredCandidates[i].id,
          starredCandidates[i].starredId,
          false
        );
        starredCandidates[i].starred = false;
        starredCandidates[i].___ControllerCard.setState({
          starred: false
        });
      }
      getControllerCandidates().reloadData();
    }
    catch (error) {
      globalErrorHandler(error);
    }
  }

  return (
    <Box row acl={Core.isAdmin({ action: ACCOUNT_ACTION__DOWNLOAD_CANDIDATES_CSV })}>
      <Button small mr1 minW120
        acl={YES__SHOW__UNSTAR_ALL}
        onClick={unstarAllCandidates}
      >
        <Icon icon='star_outlined' className='icon18 mr-1 c-inherit' />
        Unstar All
      </Button>
      {(!!selectedCandidates.length || !!starredCandidates.length) && (
        <Menu
          name='export-to-csv'
          options={[
            {
              acl: !!selectedCandidates.length,
              id: `selected_${Date.now()}`,
              label: (
                <DownloadCSV
                  filename={`candidates__${moment().format('YYYY_MM_DD__HH_mm_ss')}.csv`}
                  data={selectedCandidates.map(mapCandidateInfoForCSV)}
                  props={{
                    onClick(event) {
                      exportCandidatesInfoAndSendEmail({
                        candidates: selectedCandidates,
                        subjectTemplate: `$user export $count selected candidates info CSV on $now`
                      });
                    }
                  }}
                  className='d-flex flex-align-left-center'
                >
                  <i className='material-icons c-inherit mr-1'>file_download</i>
                  Download selected candidates
                </DownloadCSV>
              ),
            },
            {
              acl: !!starredCandidates.length,
              id: `starred_${Date.now()}`,
              label: (
                <DownloadCSV
                  filename={`candidates__${moment().format('YYYY_MM_DD__HH_mm_ss')}.csv`}
                  data={starredCandidates.map(mapCandidateInfoForCSV)}
                  props={{
                    onClick(event) {
                      exportCandidatesInfoAndSendEmail({
                        candidates: starredCandidates,
                        subjectTemplate: `$user export $count starred candidates info CSV on $now`
                      });
                    }
                  }}
                  className='d-flex flex-align-left-center'
                >
                  <i className='material-icons c-inherit mr-1'>file_download</i>
                  Download starred candidates
                </DownloadCSV>
              ),
            }
          ]}
          renderSelected={
            ({ selected }) => (
              <Button
                startIcon={<i className='material-icons c-inherit'>file_download</i>}
                disabled={YES__SENDING_EMAIL}
                className='mr-1 min-w-120'
                small
              >
                CSV<Loader loading={YES__SENDING_EMAIL}>&nbsp;</Loader>
              </Button>
            )
          }
          disabled={YES__SENDING_EMAIL}
        />
      )}
    </Box>
  );
}

export async function exportCandidatesInfoAndSendEmail({
  subjectTemplate = '',
  candidates = []
}) {
  subjectTemplate = Str(subjectTemplate);
  candidates = Arr(candidates).map(mapCandidateInfoForCSV);
  const CandidatesExportCSV = getControllerCandidatesExportCSV()
  await CandidatesExportCSV.updateState({ sendingEmail: true });
  await sendSafeEmail({
    to: mapContactsToStrings([TEN_BY_TEN__RECRUITER_CONTACT]).join(','),
    cc: mapContactsToStrings([{ name: 'April Chang', email: 'april@10by10.io' }]).join(','),
    subject: `[ Export ] ${(
      subjectTemplate
        .replace('$user', Core.getUserName())
        .replace('$count', candidates.length)
        .replace('$now', moment().tz(TIMEZONE__LA).format('YYYY-MM-DD HH:mm (z)'))
    )}`,
    html: ``,
    attachments: [
      {
        filename: `candidates__${moment().format('YYYY_MM_DD__HH_mm_ss')}.csv`,
        binary: encodeBase64(convertToCSV(candidates)),
        mimeType: 'text/csv; charset=utf-8'
      }
    ],
    source: 'CandidatesExpoxrtCSV__exportCandidatesInfoAndSendEmail',
    key: KEY__CREDENTIAL__SECONDARY,
    replyTo: KEY__CREDENTIAL__PRIMARY,
  });
  await CandidatesExportCSV.updateState({ sendingEmail: false });
}
